import { render, staticRenderFns } from "./GuideSearchResultCard.vue?vue&type=template&id=dc7ba27c&scoped=true"
import script from "./GuideSearchResultCard.vue?vue&type=script&lang=js"
export * from "./GuideSearchResultCard.vue?vue&type=script&lang=js"
import style0 from "./GuideSearchResultCard.vue?vue&type=style&index=0&id=dc7ba27c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7ba27c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default,TruncateParagraph: require('/skade-pwa/components/ui/atom/TruncateParagraph.vue').default})
